export default import.meta.ROLLDOWN_FILE_URL_Jvh_8JXd6yzQXKgTTd8z1w